module.exports = __webpack_public_path__ + "img/logo.6c3e9a27.png";